// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: '8d33fda4-705f-4ce2-b5a7-2b423caccb8f',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Smaller_Beige_Background',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '8b14a2bc-5b2d-477b-8d9b-fbf6e57d7a76',
      type: 'Text',
      runtimeType: null,
      name: '',
      className: '',
      x: -176,
      y: -14,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      text: 'More Offers',
      localize: true,
      maxWidth: 270,
      maxHeight: 92,
      maxFontSize: 0,
      style: {
        fontSize: 47,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#8F2C2B',
        stroke: '#ffffff',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {
        more_offers: {
          localize: true,
          text: 'More Offers'
        },
        back_to_top: {
          text: 'Back To The Top',
          localize: true
        }
      }
    },
    {
      id: 'cffbe7f4-1aee-449a-858c-d93ced7e3882',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 138,
      y: -12,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'More_Offer_Back_to_Top_Blue_Button_Background',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '58fb2c4f-b5d8-4664-bc06-234a8ae8bbbe',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 138,
      y: -12,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'More_Offer_Back_to_Top_Blue_Button',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'abfb0bfb-77fe-48b5-8e3b-f14285ea4f77',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 138,
      y: -12,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Blue_Plus',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {
        back_to_top: {
          texture: 'Blue_Arrow'
        },
        more_offers: {
          texture: 'Blue_Plus'
        }
      }
    }
  ],
  version: '1.0.0',
  stateNames: [
    'more_offers',
    'back_to_top'
  ],
  animations: []
} as const;

export class ShopNavigationLayout {
  static raw = raw;
  root: Container;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: 'more_offers' | 'back_to_top';
    ModelByName: {
      root: typeof raw['list'][0];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
